let accountUi = require('../actions/accountUi');

module.exports = {
    scrollPageDatepicker (path) {
        return [
            accountUi.scrollPageDatepicker(path)
        ];
    },

    scrollPageDatepickerBase (path) {
        return [
            accountUi.scrollPageDatepickerBase(path)
        ];
    },

    setDate (basePath) {
        return [
            accountUi.setDate(basePath)
        ];
    },

    unsetDate (basePath) {
        return [
            accountUi.unsetDate(basePath)
        ];
    },

    togglePopup: [
        accountUi.togglePopup
    ]
};



// WEBPACK FOOTER //
// ./signals/accountUi.js